import React from 'react';
import PropTypes from 'prop-types';

function RaaDefaultButton({
  children, additionalClass, onClick, disabled, ariaLabel,
}) {
  return (
    <button
      type="button"
      className={`btn btn-light border-1 ${additionalClass}`}
      style={{ borderColor: '#ccc' }}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

RaaDefaultButton.defaultProps = {
  additionalClass: '',
  onClick: null,
  disabled: false,
  ariaLabel: 'default button',
};

RaaDefaultButton.propTypes = {
  additionalClass: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default RaaDefaultButton;
